import styled from 'styled-components';
import { IconFlag, spacer8, Type } from '@spotify-internal/encore-web';
import { useT } from '@spotify-internal/i18n-core';
import { useShowUnassociatedVideoFlag } from '@hooks/useShowUnassociatedVideos';
import { NavBarListItemAsLink } from '@components/shared/NavBarListItemAsLink';
import { _spotify_s4mpview_v1_WhoAmIResponse_NamedEntity__Output } from '@generated/grpc/spotify/s4mpview/v1';

interface UnassociatedVideosTabProps {
  isActive: boolean;
  hrefParam: string;
  handleUnassociatedVideosTabClickGAEvent: () => void;
}

const StyledSpan = styled.span`
  padding-right: ${spacer8};
`;

const StyledType = styled(Type)`
  display: flex;
  align-items: center;
`;

export const UnassociatedVideosNavBar = ({
  isActive,
  hrefParam,
  handleUnassociatedVideosTabClickGAEvent,
}: UnassociatedVideosTabProps) => {
  const t = useT();
  const { doShow, isLoading } = useShowUnassociatedVideoFlag();

  const UNASSOCIATED_VIDEOS_TEXT = t(
    'atlas.unassociated_videos',
    'Unassociated videos',
    'Title for Unassociated videos section',
  );

  return (
    <NavBarListItemAsLink
      active={isActive}
      href={hrefParam}
      onClick={() => handleUnassociatedVideosTabClickGAEvent()}
      sentenceCase
    >
      <StyledType variant="celloCanon">
        <StyledSpan>
          {UNASSOCIATED_VIDEOS_TEXT}{' '}
          {!isLoading && doShow && (
            <IconFlag size="small" title={UNASSOCIATED_VIDEOS_TEXT} />
          )}
        </StyledSpan>
      </StyledType>
    </NavBarListItemAsLink>
  );
};
